import { Message } from 'components/message'
import I18n from 'i18n-js'
import { StatusType } from 'models/extensions'
import { Live } from 'models/live'
import React from 'react'
import ReactPlayer from 'react-player'
import { ArrowOutlineLeft } from 'react-zondicons'

interface LiveDetailPageProps {
  live: Live | undefined
  status: StatusType
  navigateToHomePage: () => void
}

type HandleSpekeStreamRequestParams = {
  initialPlaybackUrl: string
  incomingRequestUrl: string
  xhr: XMLHttpRequest
}

// Pre process http requests for SVE Speke protocol replay / live stream
// Signature is always signed once (playback url)
// We forward it to the incoming request to avoid re-signing the same url
export const handleSpekeStreamRequest = ({
  initialPlaybackUrl,
  incomingRequestUrl,
  xhr,
}: HandleSpekeStreamRequestParams) => {
  const input = new URL(incomingRequestUrl)
  const playbackUrl = new URL(initialPlaybackUrl)
  const keyPairId = playbackUrl.searchParams.get('Key-Pair-Id')
  const policy = playbackUrl.searchParams.get('Policy')
  const signature = playbackUrl.searchParams.get('Signature')

  if (
    !input.searchParams.get('Key-Pair-Id') &&
    !input.searchParams.get('Policy') &&
    !input.searchParams.get('Signature') &&
    keyPairId &&
    policy &&
    signature
  ) {
    input.searchParams.set('Policy', policy || '')
    input.searchParams.set('Key-Pair-Id', keyPairId || '')
    input.searchParams.set('Signature', signature || '')
  }
  xhr.open('GET', input.toString(), true)
}

const LiveDetailPage = ({
  status,
  live,
  navigateToHomePage,
}: LiveDetailPageProps) => {
  const renderContent = () => {
    if (status === StatusType.PENDING) {
      return <Message>{I18n.t('home-page.loading')}</Message>
    }

    if (status === StatusType.ERROR) {
      return <Message>{I18n.t('error.unknown')}</Message>
    }

    if (!live) {
      return <Message>{I18n.t('error.404')}</Message>
    }

    return (
      <div className="space-y-10">
        <h1 className="font-semibold text-primary text-center text-xl md:text-2xl uppercase">
          {live.title}
        </h1>
        <ReactPlayer
          url={live.url}
          width="100%"
          height="100%"
          playing
          controls
          config={{
            file: {
              hlsOptions: {
                xhrSetup: (xhr: XMLHttpRequest, incomingRequestUrl: string) =>
                  handleSpekeStreamRequest({
                    initialPlaybackUrl: live.url,
                    incomingRequestUrl,
                    xhr,
                  }),
              },
            },
          }}
        />
      </div>
    )
  }

  return (
    <>
      <ArrowOutlineLeft
        className="pb-6 fill-current text-white cursor-pointer"
        onClick={navigateToHomePage}
        size={60}
      />
      <div className="max-w-4xl mx-auto">{renderContent()}</div>
    </>
  )
}

export default LiveDetailPage
